import "../pages.scss"
import { SubrubrosState } from '../../context/subrubros/SubrubrosState';
import Datatable from "./subrubrosTable/Datatable"

const SubrubrosPage = () => {
  return (
    <>
      <SubrubrosState>
        <Datatable />
      </SubrubrosState>

    </>
  )
}

export default SubrubrosPage;